import {
    TOGGLE_MOBILE_SIDE_MENU,
} from '../Actions/ui';

const initialState = {
    isMobileSideMenuOpen: false
};

// TODO: refactor - start moving here controls from main
export default function(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_MOBILE_SIDE_MENU:
            return {...state, isMobileSideMenuOpen: !state.isMobileSideMenuOpen};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/ui.js